<template>
  <div class="beneficios">
    <div class="row">
      <div class="col-xs-12">
        <h2 class="page-header">Benefícios Assistenciais</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :show-empty="true"
          title="Lista de Benefícios"
          api-url="assistencia/beneficios/listar"
          report-title="Benefícios"
          :initial-page="pagina"
          :pageCollection="'beneficiosAssistenciais'"
          :fields="fields"
        >
          <template slot="actions">
            <router-link
              class="btn btn-default"
              :to="'/admin/assistencia/beneficios/edit'"
            >
              <font-awesome-icon :icon="'plus'" /> Adicionar
            </router-link>
          </template>
          <template slot="rowrender" slot-scope="props">
            <div class="">
              <button
                title="Editar"
                type="button"
                class="btn btn-primary"
                @click="
                  $router.push({
                    name: 'beneficios_edit',
                    params: { item: props.rowData }
                  })
                "
              >
                <font-awesome-icon :icon="'edit'" />
              </button>
              <button
                title="Excluir"
                class="btn btn-danger"
                @click="excluir(props.rowData)"
              >
                <font-awesome-icon :icon="'trash'" />
              </button>
            </div>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  inject: ['showConfirm'],
  components: {
    DataTable
  },
  data() {
    return {
      fields: [
        {
          name: 'sigla',
          title: 'Benefício'
        },
        {
          name: 'nome',
          title: 'Nome'
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  methods: {
    excluir(item) {
      var dt = this.$refs.vuetable

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .post('assistencia/beneficios/excluir', item)
            .then(response => {
              this.$toastr.s(response.data.msg)
            })
            .catch(error => {
              const { data } = error.response
              this.$toastr.e(
                'Houve um erro ao tentar excluir, atualize a página e tente novamente'
              )
              console.log(data.msg)
            })
            .finally(() => {
              dt.refresh()
            })
        }
      }
      this.showConfirm('Deseja realmente deletar este item?', config)
    }
  },
  computed: {
    pagina: {
      get() {
        const { beneficiosAssistenciais } = this.$store.state.vuetableState
        const { pagina } = beneficiosAssistenciais
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'beneficiosAssistenciais',
          value: value
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/assistencia/beneficios/index.vue